<script>
import Vue from 'vue'
import Settings from '@/helpers/Settings'
import FormFieldBase from './FormFieldBase'
import {findFirstChild} from '@/helpers/Utils'

const theme = require('@/helpers/Settings').default.theme

const Template = require('./themes/' + theme + '/FormField').default

let requireTheme = require.context('./themes/', true)

let componentTemplates = {
    // use default theme template defined in FormFieldBase
    default: {
        mixins: [
            FormFieldBase,
            Template
        ]
    },
    inline: {
        mixins: [
            FormFieldBase,
            Template,
            requireTheme('./'+theme+'/FormFieldInline').default
        ]
    },
    view: {
        mixins: [
            FormFieldBase,
            Template,
            requireTheme('./'+theme+'/FormFieldView').default
        ]
    },
    // custom
    checkbox: {
        mixins: [
            FormFieldBase,
            Template,
            requireTheme('./'+theme+'/FormFieldCheckbox').default
        ]
    },
    switch: {
        mixins: [
            FormFieldBase,
            Template,
            requireTheme('./'+theme+'/FormFieldSwitch').default
        ]
    },
    date: {
        mixins: [
            FormFieldBase,
            Template,
            requireTheme('./'+theme+'/FormFieldDate').default
        ]
    },
    password: {
        mixins: [
            Template,
            requireTheme('./'+theme+'/FormFieldPassword').default
        ]
    }
}

export default {
    name: 'oc-form-field',
    functional: true,
    inject: {
        access: {
            default: false
        },
        formFieldOptions: {
            default: false
        }
    },
    props: {
        theme: {
            type: [String, Boolean],
            default: false,
            validator: function (value) {
                return [false, 'default', 'inline', 'view', 'checkbox', 'switch', 'date', 'password'].indexOf(value) !== -1
            }
        }
    },
    render(createElement, context) {
        // --------------------------- //

        let formFieldOptions = context.injections.formFieldOptions || {}

        let template = 'default'

        if( formFieldOptions.theme !== undefined ) {
            template = formFieldOptions.theme
        }

        if( context.props.theme ) {
            template = context.props.theme
        }
        else if ( context.data.attrs !== undefined && context.data.attrs.$mode !== undefined ) {
            if( inArray(context.data.attrs.$mode, Settings.get('viewModes', [])) ) {
                template = 'view'
            }
        }
        else if( context.injections.access && context.injections.access.isViewMode ) {
            template = 'view'
        } else {
            let access = findFirstChild(context.parent, 'oc-access-control')
            if( access && inArray(access.mode, access.viewModes) ) {
                template = 'view'
            }
        }

        let component = componentTemplates[template]

        component.name = 'oc-form-field'
        // --------------------------- //

        let data = Object.assign(
            {},
            context.data,
            {
                scopedSlots: context.scopedSlots,
                slots: context.slots,
                on: context.listeners
            }
        )

        if( data.attrs === undefined ) {
            data.attrs = {}
        }

        data.attrs = Object.assign({}, formFieldOptions, data.attrs);

        return createElement(
            component,
            data,
            context.children
        )
    }
}
</script>
